'use client';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import Button, { ButtonProps } from '@repo/ui/src/components/Button';
import LoadingLogo from '@components/Loading/LoadingLogo';
import { classNames } from '@repo/ui/src/utils/classNames';

type BaseButtonWithProgressProps<ComponentType = 'button'> = ButtonProps<ComponentType> & {
  processing?: boolean;
  processingText?: string | false;
  text?: string;
  onClick?: (e: any) => void;
  disabled?: boolean;
};

type ButtonType = <T>(props: BaseButtonWithProgressProps<T>) => JSX.Element;

const BaseButtonWithProgress: ButtonType = ({
  processing,
  processingText,
  text,
  children,
  ...other
}) => {
  const { t } = useTranslation();

  return (
    // @ts-expect-error mismatched props
    <Button disabled={processing} {...other}>
      <div className="tw-relative">
        <span
          className={classNames(
            'tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-max-w-full',
            !processing && 'tw-opacity-0',
          )}
        >
          <LoadingLogo svgClassName="tw-h-5" />
          {processingText !== false &&
            (processingText ??
              t('genericContent.loadingLabel', undefined, { default: 'Loading...' }))}
        </span>

        <span className={classNames(processing && 'tw-opacity-0')}>{text || children}</span>
      </div>
    </Button>
  );
};

export default BaseButtonWithProgress;
